import { alphaNumericComparator } from '@/modules/base/components/list/comparator'
import ListColumnModel from '@/modules/base/model/list-column-model'

export default class BookingListColumnModel extends ListColumnModel {
  constructor(data) {
    super(data)
    this.displayed = data.displayed
    this.setColumnSpecificProperties()
  }

  setColumnSpecificProperties() {
    switch (this.name) {
      case 'amount': {
        this.setCurrencyType()
        this.comparator = alphaNumericComparator
        break
      }

      case 'date': {
        this.setDateType()
        break
      }
    }
  }
}
